import React from 'react';

import { Link } from 'react-router';

import { formatMoney } from '../../shared/format';

function EventCount({ mailings, type, event, isAtLeastOneUniqueEvent, reach, count }) {
	const href = `/statistics/general?mailings=${mailings}&type=${type}&event=${event}`;
	const percent = ((count / reach) * 100) || 0;

	return (
		<div className='mailings-new-list-event-count'>
			<Link
				className={isAtLeastOneUniqueEvent ? 'mailings-new-list-event-link' : null}
				href={isAtLeastOneUniqueEvent ? href : null}
				target='_blank'
				onClick={(e) => {
					if (isAtLeastOneUniqueEvent) e.stopPropagation();
				}}
			>
				{formatMoney(count)}
			</Link>
			<div className='mailings-new-list-event-percent'>
				{percent.toFixed(2)} %
			</div>
		</div>
	);
}

export default EventCount;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/mailings-new/components/event-count.js